import r2wc from "@r2wc/react-to-web-component";
import App from "./App.tsx";

/**
 * React to webcomponent plugin
 * https://github.com/bitovi/react-to-web-component
 */

const WebCompApp = r2wc(App, {
  shadow: "open",
  props: {
    tourid: "number",
    userid: "number",
    iseditor: "boolean",
    jwt: "string",
    lang: "string"
  },
},);





customElements.define("web-app-component", WebCompApp);
